// @ts-nocheck

/**
 * * `ACTIVE` - Active
 * `CANCELLED` - Cancelled
 * `EXPIRED` - Expired
 * `PENDING` - Pending
 * `PAUSED` - Paused
 * `BILLING_ISSUE` - Billing Issue
 */
export type UserSubscriptionStatusEnum =
  typeof UserSubscriptionStatusEnum[keyof typeof UserSubscriptionStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserSubscriptionStatusEnum = {
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
  PENDING: "PENDING",
  PAUSED: "PAUSED",
  BILLING_ISSUE: "BILLING_ISSUE",
} as const;
